import { render, staticRenderFns } from "./jv_eliminasifrm.vue?vue&type=template&id=e8518544"
import script from "./jv_eliminasifrm.vue?vue&type=script&lang=js"
export * from "./jv_eliminasifrm.vue?vue&type=script&lang=js"
import style0 from "./jv_eliminasifrm.vue?vue&type=style&index=0&id=e8518544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports